// MUIS
import { alpha } from '@mui/material/styles'

const black = '#000000'
const white = '#FFFFFF'

export const colors = {
  // PRIMARY (ORANGE)
  primary: {
    main: '#F96649',
    light: '#FA8067',
    dark: '#CF553D',
    contrastText: white,
    containedHoverBackground: '#913C2B',
    outlinedHoverBackground: alpha('#F96749', 0.08),
    outlinedRestingBackground: alpha('#F96749', 0.5),
  },
  // SECONDARY (GREEN BLUE)
  secondary: {
    main: '#4DBFAA',
    light: '#6BCAB8',
    dark: '#409F8E',
    contrastText: white,
    containedHoverBackground: '#2D6F63',
    outlinedHoverBackground: alpha('#4DBFAA', 0.08),
    outlinedRestingHover: alpha('#4DBFAA', 0.5),
  },
  // ERROR (RED)
  error: {
    main: '#F44336',
    light: '#F88078',
    dark: '#E31B0C',
    contrastText: white,
    containedHoverBackground: '#AB2F26',
    outlinedHoverBackground: alpha('#F44336', 0.08),
    outlinedRestingBorder: alpha('#F44336', 0.5),
    content: '#621B16',
    background: '#FEECEB',
  },
  // INFO (BLUE)
  info: {
    main: '#2196F3',
    light: '#64B6F7',
    dark: '#0B79D0',
    contrastText: white,
    containedHoverBackground: '#1769AA',
    outlinedRestingBorder: alpha('#2196F3', 0.50),
    outlinedHoverBackground: alpha('#2196F3', 0.08),
    content: '#0D3C61',
    background: '#E9F5FE',
  },
  // WARNING (DARK ORANGE)
  warning: {
    main: '#ED6C02',
    light: '#FFB547',
    dark: '#C77700',
    contrastText: white,
    containedHover: '#A64C01',
    outlinedRestingBorder: alpha('#ED6C02', 0.50),
    outlinedHoverBackground: alpha('#ED6C02', 0.08),
    content: '#5F2B01',
    background: '#FDF0E6',
  },
  // SUCCESS (GREEN)
  success: {
    main: '#4CAF50',
    light: '#7BC67E',
    dark: '#3B873E',
    contrastText: white,
    containedHoverBackground: '#357A38',
    outlinedRestingBorder: alpha('#4CAF50', 0.50),
    outlinedHoverBackground: alpha('#4CAF50', 0.08),
    content: '#1E4620',
    background: '#EDF7ED',
  },
  // TEXT (BLACK)
  text: {
    primary: '#2F2F30',
    secondary: alpha(black, 0.6),
    disabled: alpha(black, 0.4),
  },
  // BACKGROUND
  background: {
    paper: white,
    default: '#F0F0F0',
  },
}